<template>
    <date-picker v-model="userInput"
                 :format="format"
                 :name="name"
                 :clearable="clearable"
                 :disabled="disabled"
                 :append-to-body="appendToBody"
                 @change="handleValueChange"
                 ref="datepicker"
                 lang="en" style="float: right;">
        <div slot="footer" v-if="customButton">
            <div class="dpc-btn-today">
                <a class="" @click="clickToday()">TODAY</a>
            </div>
        </div>
    </date-picker>
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
  name: 'DatePickerCustom',
  components: { DatePicker },
  mixins: [],
  directives: {},
  props: {
    value: {
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    lang: {
      type: [String, Object],
      default: 'en'
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    type: {
      type: String,
      default: 'date' // ['date', 'datetime'] zendy added 'month', 'year', mxie added "time"
    },
    range: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    shortcuts: {
      type: [Boolean, Array],
      default: true
    },
    inputName: {
      type: String,
      default: 'date'
    },
    inputClass: {
      type: [String, Array],
      default: 'mx-input'
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    customButton: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: 'date'
    }
  },
  data () {
    return {
      userInput: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.userInput = newVal
      },
      deep: true
    }
  },
  computed: {},
  mounted () {
    this.userInput = this.value
  },
  beforeDestroy () {

  },
  methods: {
    clickToday () {
      this.userInput = new Date()
      this.handleValueChange()
      if (this.$refs.datepicker) {
        this.$refs.datepicker.closePopup()
      }
    },
    handleValueChange () {
      if (this.userInput !== this.value) {
        this.$emit('input', this.userInput)
        this.$emit('change', this.userInput)
      }
    }
  }
}
</script>
<style>
    .dpc-btn-today {
        text-align: center;
        cursor: pointer;
        padding: 5px;
    }
    .dpc-btn-today > a {
        color: #bec500 !important;
    }
</style>
